import { render, staticRenderFns } from "./CardLinkPagos.vue?vue&type=template&id=694e5f89&"
import script from "./CardLinkPagos.vue?vue&type=script&lang=js&"
export * from "./CardLinkPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports